<template>
    <div v-if="title" :class="cssClass || ''" class="page-title">
        <slot name="prepend"></slot>
        <h1 class="text">
            <slot name="icon-prepend"></slot>
            {{title}}
            <slot name="icon-append"></slot>
        </h1>
        <slot name="append"></slot>
    </div>
</template>

<script>
export default {
    name : 'PageTitle',
    props: {
        title   : String,
        cssClass: String
    }
}
</script>

<style scoped>
    .page-title > * {
        margin: 0 0 34px;
    }
    .page-title .text {
        color: #151515;
        font-size: 24px;
    }
</style>
